import {MOON_500} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const ButtonPanel = styled.div`
  margin: 12px 0 12px 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
ButtonPanel.displayName = 'S.ButtonPanel';

export const ClearMessage = styled.div`
  margin-right: 12px;
  font-size: 14px;
  color: ${MOON_500};
`;
ClearMessage.displayName = 'S.ClearMessage';
